import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_SITE_URL = process.env.REACT_APP_SITE_URL || 'https://happyyatratravels.in';
const getSiteUrl = () => (typeof window !== 'undefined' ? window.location.origin : DEFAULT_SITE_URL);

/**
 * SEO component for per-page meta tags, Open Graph, and Twitter Cards.
 * Use on every page for unique titles and descriptions.
 */
const SEO = ({
  title,
  description,
  image,
  canonical,
  noindex = false,
  type = 'website',
  publishedTime,
  modifiedTime,
  author,
  keywords,
}) => {
  const siteUrl = getSiteUrl();
  const defaultImage = `${siteUrl}/logo.png`;
  const fullTitle = title ? `${title} | Happy Yatra Travels` : 'Happy Yatra Travels - Discover the Joy of Travel';
  const fullDescription = description || 'Book your dream vacation with Happy Yatra Travels. Tour packages, spiritual journeys, and travel services across India and beyond.';
  const canonicalUrl = canonical ? (canonical.startsWith('http') ? canonical : `${siteUrl}${canonical}`) : siteUrl;
  const imageUrl = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="Happy Yatra Travels" />
      <meta property="og:locale" content="en_IN" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {author && <meta property="article:author" content={author} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;
